var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2293.175227,-483.683634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.334438,0,0,0.334438,1761.753042,409.438369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1843.49,422.333C1820.489,464.424 1775.805,493 1724.5,493C1649.716,493 1589,432.284 1589,357.5C1589,282.716 1649.716,222 1724.5,222C1775.805,222 1820.489,250.576 1843.49,292.667L1721,292.667C1685.218,292.667 1656.167,321.718 1656.167,357.5C1656.167,393.282 1685.218,422.333 1721,422.333L1843.49,422.333ZM1858.024,334.333C1859.323,341.862 1860,349.603 1860,357.5C1860,365.397 1859.323,373.138 1858.024,380.667L1721,380.667C1708.214,380.667 1697.833,370.286 1697.833,357.5C1697.833,344.714 1708.214,334.333 1721,334.333L1858.024,334.333Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoContact);
export default __webpack_public_path__ + "static/media/logo-contact.7e2887bc289aad2327275ee13a3a4a50.svg";
export { ForwardRef as ReactComponent };